import { render, staticRenderFns } from "./PotentialGraph.vue?vue&type=template&id=4e33b059"
import script from "./PotentialGraph.vue?vue&type=script&lang=js"
export * from "./PotentialGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports